import React from 'react';
import { Box, Button, Container, CssBaseline, Fab, GridLegacy, TextField, Typography } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { AppGlobalContext } from '../../../App';
import ProfileImagePickerComponent from '../../Common_Components/FieldTypes/ProfileImagePicker';

/*
@startuml
Title Static architecture of sign up page
class SignUp_page_body {
    - String subpage
    - String email
    - String password
    - String password_confirm
    - String firstName
    - String lastName
    - boolean email_invalid
    - boolean password_length_ok
    - boolean password_contains_number_ok
    - boolean password_contains_special_ok
    - boolean password_contains_uppercase_ok
    - boolean password_contains_lowercase_ok
    - String theSixNumber
    - String theSixNumber_confirm
    - boolean paused
    - boolean submitActivation
    - int countdown  'Changed to number/int for countdown
    - int counter_timeout_id  'Changed to number/int for id
    + boolean checkSubmitActivation()
    + void verifyEmailRequest() 'Corrected typo
}

class Timer {
    - int duration 'Changed to number/int for timer
    + void handleClick()
}

AppGlobalContext <|-- SignUp_page_body : uses
SignUp_page_body *-- Timer : contains


@enduml


*/

/* 
@startuml
Title State machine of sign up page
[*] -down-> Login

state Login {
}

state SignUp_page_body {
  state SignUp_subpage {
  }
  
  state VarifyEmail_subpage {
  }

  [*] --> SignUp_subpage
  SignUp_subpage --> VarifyEmail_subpage : Verify Email Clicked / verifyEmailRequest()
  SignUp_subpage : set of text fields of:
  SignUp_subpage : email
  SignUp_subpage : firstName
  SignUp_subpage : lastName
  SignUp_subpage : password
  SignUp_subpage --> [*] : User back to Login / setPageName("Login")
  VarifyEmail_subpage --> [*] : Account Created / setPageName("Login")
  VarifyEmail_subpage --> SignUp_subpage : Back to Sign Up Clicked / setSubpage("SignUp")
  VarifyEmail_subpage --> VarifyEmail_subpage : Resend Clicked / verifyEmailRequest() tells email already exists

  VarifyEmail_subpage : text field for 6 digit varification
}

Login -down-> SignUp_page_body : User don't have an account / setPageName("SignUp")
SignUp_page_body --> Login : User already have an account or created

@enduml
*/

function Timer(props) {
  const [duration, setDuration] = React.useState(props.duration);
  // const [props.paused, props.setPaused] = React.useState(true);

  React.useEffect(() => {
    let timerId;
    if (!props.paused) {
      timerId = setInterval(() => {
        setDuration((prev) => prev - 1);
      }, 1000);
      console.log(timerId);
    }

    return function cleanup() {
      console.log(`Clearing ${timerId}`);
      clearInterval(timerId);
    };
  }, [props.paused]);

  const handleClick = (e) => {
    !props.paused ? props.setPaused(true) : props.setPaused(false);
  };

  return (
    <>
      {duration >= 0 ? <h3>{duration}</h3> : setDuration(0)}
      {/* <button paused={props.paused} onClick={handleClick} /> */}
    </>
  );
}
function SignUp_page_body() {
  const [subpage, setSubpage] = React.useState("SignUp");
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [password_confirm, setPassword_confirm] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [profileImage, setProfileImage] = React.useState(null);
  const [profileImageBase64, setProfileImageBase64] = React.useState(null);
  const [faceDescriptor, setFaceDescriptor] = React.useState(null);
  /************************* conditional validation *************************/
  const [email_invalid,setEmail_invalid] = React.useState(false)
  const [password_length_ok,setPassword_length_ok] = React.useState(true)
  const [password_contains_number_ok,setPassword_contains_number_ok] = React.useState(true)
  const [password_contains_special_ok,setPassword_contains_special_ok] = React.useState(true)
  const [password_contains_uppercase_ok,setPassword_contains_uppercase_ok] = React.useState(true)
  const [password_contains_lowercase_ok,setPassword_contains_lowercase_ok] = React.useState(true)
  const [theSixNumber, setTheSixNumber] = React.useState(' ');
  const [theSixNumber_confirm, setTheSixNumber_confirm] = React.useState('');
  const [paused,setPaused]=React.useState(false)
  /**************************************************************************/
  const [submitActivation, setSubmitActivation] = React.useState(false);
  const [countdown, setCountdown] = React.useState(300);
  let counter_timeout_id = 0
  const AppGlobalContxt = React.useContext(AppGlobalContext);
  const varifyEmailRequest = async () => {
    let response = window.devMode ? fetch(`http://localhost:80/VerifyEmail/EN/${firstName}/${email}`,
      {
        username: "asd",
        password: "1234"
      },
      {
        mode: 'no-cors',
        url: `http://localhost:80`
      }
    ) : fetch(`/VerifyEmail/EN/${firstName}/${email}`)
    let data = await response.then((res) => res.text())
    console.log(data)
    setTheSixNumber(data)
    // counter_timeout_id = setInterval(() => {
    //   if (countdown > 0)
    //     {
    //       // setCountdown(countdown - 1)
    //     }
    //   else
    //   {
    //     setCountdown(300)
    //     clearInterval(counter_timeout_id)
    //     setTheSixNumber(" ")
        
    //   }
    // }, 1000)
    
  }
  const handleProfileImageChange = async (file) => {
    if (file) {
      setProfileImage(file);
      
      // Convert to base64 for storage
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImageBase64(reader.result);
      };
      reader.readAsDataURL(file);
      
      // Detect face descriptor
      try {
        const image = await window.faceapi.bufferToImage(file);
        const detection = await window.faceapi
          .detectSingleFace(image)
          .withFaceLandmarks()
          .withFaceDescriptor();
        
        if (detection) {
          setFaceDescriptor(Array.from(detection.descriptor));
          console.log('[SignUp] Face descriptor detected');
        } else {
          console.warn('[SignUp] No face detected in image');
        }
      } catch (error) {
        console.error('[SignUp] Error detecting face:', error);
      }
    }
  };
  
  const checkSubmitActivation = () => {
    return (
      !email_invalid &&
      password === password_confirm && 
      password_length_ok &&
      password_contains_number_ok &&
      password_contains_special_ok &&
      password_contains_uppercase_ok &&
      password_contains_lowercase_ok &&
      password!=='' &&
      email!=='' &&
      firstName!=='' &&
      lastName!==''
    )
  }
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Fab color="secondary" aria-label="add" sx={{ position: 'fixed', top: 16, left: 16 }}
        onClick={() => {
          switch (subpage) {
            case "SignUp":
              AppGlobalContxt.Body.setPageName("Login")
              break;
            case "VarifyEmail_subpage":
              setSubpage("SignUp")
              break;
            default:
              break;
          }
      }}  >
        <ArrowBackIcon />
      </Fab>
      <Box
        sx={{
          marginTop: 8,
          flexDirection: 'column',
          alignItems: 'center',
        }}
        hidden={ subpage != "SignUp"}
      >
        <Typography component="h1" variant="h5">Sign up</Typography>
        <Box component="form" noValidate sx={{ mt: 3 }}>
          <GridLegacy container spacing={2} >
            <GridLegacy item xs={12}>
              <TextField
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email" autoComplete="email" value={email} onChange={(e) => {
                  setEmail(e.target.value);
                  setSubmitActivation(true);
                }}
                onBlur={
                  async () =>{
                    let email_is_okay = false
                    if (email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
                      setEmail_invalid(false)
                    }else{
                      setEmail_invalid(true)
                    }
                    
                    email_is_okay = email_invalid & true
                    setSubmitActivation(email_is_okay)
                  }
                }
              />
            </GridLegacy>
            <GridLegacy item xs={12} sm={6}>
              <TextField
                autoComplete="fname"
                name="firstName"
                required
                fullWidth
                id="firstName"
                label="First Name"
                autoFocus
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);}}
              />
            </GridLegacy>
            <GridLegacy item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                autoComplete="lname"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
              />
            </GridLegacy>
            <GridLegacy item xs={12}>
              <ProfileImagePickerComponent
                properties={{
                  options: {
                    label: 'Upload Profile Picture',
                    variant: 'outlined',
                    onChange: handleProfileImageChange
                  },
                  constrains: {
                    accept: 'image/*',
                    maxSize: 5242880 // 5MB
                  }
                }}
              />
            </GridLegacy>
            <GridLegacy item xs={12}>
              <TextField
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  password.length >= 8 ? setPassword_length_ok(true) : setPassword_length_ok(false)
                  password.match(/[0-9]/) ? setPassword_contains_number_ok(true) : setPassword_contains_number_ok(false)
                  password.match(/[a-z]/) ? setPassword_contains_lowercase_ok(true) : setPassword_contains_lowercase_ok(false)
                  password.match(/[A-Z]/) ? setPassword_contains_uppercase_ok(true) : setPassword_contains_uppercase_ok(false)
                  password.match(/[^a-zA-Z0-9]/) ? setPassword_contains_special_ok(true) : setPassword_contains_special_ok(false)
                }}
              />
            </GridLegacy>
            <GridLegacy item xs={12}>
              <TextField
                required
                fullWidth
                name="password_confirm"
                label="Password_confirm"
                type="password"
                id="password_confirm"
                autoComplete="new-password"
                value={password_confirm}
                onChange={
                  (e) => {
                    setPassword_confirm(e.target.value);
                  }
                }
              />
            </GridLegacy>
            <GridLegacy item xs={12}>
              <Button
                disabled={!checkSubmitActivation()}
                type="button"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={
                  async () => {
                    setSubpage("VarifyEmail_subpage")
                    varifyEmailRequest()
                  }
                }
              >
                Varify the email
              </Button>
            </GridLegacy>
          </GridLegacy>
          <GridLegacy container justifyContent="flex-end" direction={'column-reverse'}>
            <GridLegacy item xs={12} hidden={!email_invalid}>
              <Typography variant="body2" color={'error'} fontWeight={'bold'}>This email is not valid</Typography>
            </GridLegacy>
          </GridLegacy>
          <GridLegacy container justifyContent="flex-end" direction={'column-reverse'}>
            <GridLegacy item xs={12} hidden={password === password_confirm}>
              <Typography variant="body2" color={'error'} fontWeight={'bold'}>password not match the confirmation</Typography>
            </GridLegacy>
          </GridLegacy>
          <GridLegacy container justifyContent="flex-end" direction={'column-reverse'}>
            <GridLegacy item xs={12} hidden={password_length_ok}>
              <Typography variant="body2" color={'error'} fontWeight={'bold'}>password length must be at least 8</Typography>
            </GridLegacy>
          </GridLegacy>
          <GridLegacy container justifyContent="flex-end" direction={'column-reverse'}>
            <GridLegacy item xs={12} hidden={password_contains_number_ok}>
              <Typography variant="body2" color={'error'} fontWeight={'bold'}>password must contain at least one number</Typography>
            </GridLegacy>
          </GridLegacy>
          <GridLegacy container justifyContent="flex-end" direction={'column-reverse'}>
            <GridLegacy item xs={12} hidden={password_contains_lowercase_ok}>
              <Typography variant="body2" color={'error'} fontWeight={'bold'}>password must contain at least one lowercase</Typography>
            </GridLegacy>
          </GridLegacy>
          <GridLegacy container justifyContent="flex-end" direction={'column-reverse'}>
            <GridLegacy item xs={12} hidden={password_contains_uppercase_ok}>
              <Typography variant="body2" color={'error'} fontWeight={'bold'}>password must contain at least one uppercase</Typography>
            </GridLegacy>
          </GridLegacy>
          <GridLegacy container justifyContent="flex-end" direction={'column-reverse'}>
            <GridLegacy item xs={12} hidden={password_contains_special_ok}>
              <Typography variant="body2" color={'error'} fontWeight={'bold'}>password must contain at least one special character</Typography>
            </GridLegacy>
          </GridLegacy>

        </Box>
      </Box>
      <Box
        sx={{
          marginTop: 8,
          flexDirection: 'column',
          alignItems: 'center',
        }}
        hidden={ subpage != "VarifyEmail_subpage"}>
        <Typography component="h1" variant="h5">Check your email OTP will be invalid after</Typography>
        <br/>
        {/* <Typography component="h1" variant="h5">{countdown} second</Typography> */}
        <Timer duration={300} paused={paused} setPaused={setPaused}/>
        {/* <Typography variant='body2'>enter the 6 number you received</Typography> */}
          <GridLegacy container spacing={2} >
          <GridLegacy item xs={12}>
              <TextField
                required
                fullWidth
                name="Varification code"
                label="Varification code"
                id="theSixNumber_confirm"
                helperText="enter the 6 number you received"
                value={theSixNumber_confirm}
                onChange={
                  (e) => {
                    setTheSixNumber_confirm(e.target.value);
                  }
                }
              />
            </GridLegacy>
            <GridLegacy item xs={12}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={theSixNumber_confirm!==theSixNumber}
                onClick={
                  async () => {
                    let response;
                    const userData = {
                      email, 
                      firstName, 
                      lastName, 
                      password,
                      profileImage: profileImageBase64,
                      profileImageDescriptor: faceDescriptor
                    };
                    
                    if (window.devMode) {
                      response = await fetch(`http://localhost:80/add_user`,
                        {
                          mode: 'no-cors',
                          url: `http://localhost:80`,
                          method: 'POST',
                          headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                          },
                          body: JSON.stringify(userData)
                        },
                        {
                          username: "asd",
                          password: "1234"
                        }
                      )
                    } else {
                      response = await fetch(`/add_user`,
                        {
                          method: 'POST',
                          body: JSON.stringify(userData),
                          headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                          }
                        }
                      )
                    }
                    // setSubpage("Login")
                    AppGlobalContxt.Body.setPageName("Login")
                  }
                }
              >
                Create Account
              </Button>
            </GridLegacy>
            <GridLegacy item xs={12}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={
                  async () => {
                    setSubpage("SignUp")
                  }
                }
              >
                Resend
              </Button>
            </GridLegacy>
            <GridLegacy item xs={12}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={
                  async () => {
                    setSubpage("SignUp")
                  }
                }
              >
                Back to Sign up
              </Button>
            </GridLegacy>
          </GridLegacy>
        </Box>
    </Container>
  );
}

export default SignUp_page_body;